import React from 'react'
import Containerx from '../Containerx/Containerx';
import Quote from '../Quote/Quote';
import Skill from '../Skill/Skill';

import skills from '../../services/Skills';

import "./Home.css";

import {motion} from "framer-motion";

export default function Home() {
    return (

        <motion.div 
            initial={{opacity : 0}}
            exit={{opacity: 0}}
            animate={{opacity : 1}}
        >   

        <Containerx>
  
        <div className="home-container">
            <h2 className="home__title"><span className="big">Hello world! 🌎</span> <br></br>  <span className="medium">I'm Aravinda krishnan</span></h2>
            <p className="home__desc">I'm a <span className="highlight">Full stack enthusiast</span> , I love to create web applications using <span className="highlight">MERN</span> stack ! and I'm a daily=skill++ guy.</p>

            <div className="skill-container">
            {
                skills.map(skill => {
                   return <Skill key={skill.id} skill={skill.skill} color={skill.color}/>
                })
            }
            </div>
            
            <div className="home__resume__downloader">
                <a href="https://files.smallpdf.com/files/8be7bda5dab022cf270602e4c486cd5f.pdf?name=Resume.pdf">Download Resume</a>
            </div>
 
        </div>

        <Quote></Quote>


        </Containerx>
        </motion.div>
    )
}
